import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ breakpoints, tokens }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    position: 'relative',
  },
  main: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    paddingTop: tokens.spacing['20'],
    [breakpoints.up('md')]: {
      paddingTop: tokens.spacing['20'],
      paddingBottom: tokens.spacing['40'],
    },
  },
  appBar: {
    paddingLeft: tokens.spacing['20'],
    paddingRight: tokens.spacing['20'],

    [breakpoints.up('md')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  header: {
    position: 'sticky',
    top: 0,
    zIndex: 1200,
    paddingLeft: tokens.spacing['16'],
    paddingRight: tokens.spacing['16'],
    background: tokens.colors.bg.light.primary,
    borderBottom: `1px solid ${tokens.colors.stroke.primary}`,

    [breakpoints.up('md')]: {
      paddingTop: tokens.spacing['20'],
      paddingLeft: tokens.spacing['32'],
      paddingBottom: tokens.spacing['20'],
      paddingRight: tokens.spacing['32'],
    },
  },
  content: {
    width: '100%',
    maxWidth: '1296px',
    margin: '0 auto',

    [breakpoints.up('md')]: {
      maxWidth: 'calc(1296px + 48px)',
      paddingLeft: tokens.spacing['24'],
      paddingRight: tokens.spacing['24'],
    },

    [breakpoints.up('lg')]: {
      maxWidth: 'calc(1296px + 80px)',
      paddingLeft: tokens.spacing['40'],
      paddingRight: tokens.spacing['40'],
    },
  },
  container: {
    flexGrow: 1,
    padding: 0,
    margin: '0 auto',
    position: 'relative',
    [breakpoints.up('lg')]: {
      maxWidth: 1280,
    },
  },

  dashboardHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 1200,
    paddingTop: tokens.spacing['20'],
    paddingLeft: tokens.spacing['32'],
    paddingRight: tokens.spacing['32'],
    background: tokens.colors.bg.light.primary,
    borderBottom: `1px solid ${tokens.colors.stroke.primary}`,
    borderRadius: `0 0 ${tokens.radius.l}px ${tokens.radius.l}px`,

    [breakpoints.down('md')]: {
      paddingTop: tokens.spacing['20'],
      paddingLeft: tokens.spacing['16'],
      paddingRight: tokens.spacing['16'],
    },
  },
}));
